import { Box } from '@chakra-ui/react';
import React from 'react';

import { BorrowingBaseSummaryAccordion } from './BorrowingBaseSummaryAccordion';
import { BorrowingBaseSummaryAccordionRow } from './BorrowingBaseSummaryAccordionRow';
import { BorrowingBaseSummarySectionHeader } from './BorrowingBaseSummarySectionHeader';
import {
  BorrowingBaseSummaryInput,
  getColumnValuesForBorrowingBaseReportField,
} from './utils';

export const BorrowingBaseSummaryFacilitySummary: React.FC<{
  borrowingBaseReports: BorrowingBaseSummaryInput;
  showComparisonAndDifferenceColumns: boolean;
}> = ({ borrowingBaseReports, showComparisonAndDifferenceColumns }) => {
  return (
    <Box marginTop="32px">
      <BorrowingBaseSummarySectionHeader headerLabel="Facility Summary" />
      <BorrowingBaseSummaryAccordion
        accordionButton={({ hasAccordionPanel, isExpanded }) => (
          <BorrowingBaseSummaryAccordionRow
            label="Current Principal Balance"
            columnValues={getColumnValuesForBorrowingBaseReportField({
              borrowingBaseReports,
              fieldName: 'currentPrincipalBalance',
            })}
            valueType="currency"
            hasAccordionPanel={hasAccordionPanel}
            isExpanded={isExpanded}
            showComparisonAndDifferenceColumns={
              showComparisonAndDifferenceColumns
            }
            fieldName="currentPrincipalBalance"
          />
        )}
      />
      <BorrowingBaseSummaryAccordion
        accordionButton={({ hasAccordionPanel, isExpanded }) => (
          <BorrowingBaseSummaryAccordionRow
            label="Commitment Amount"
            columnValues={getColumnValuesForBorrowingBaseReportField({
              borrowingBaseReports,
              fieldName: 'commitmentAmount',
            })}
            valueType="currency"
            hasAccordionPanel={hasAccordionPanel}
            isExpanded={isExpanded}
            showComparisonAndDifferenceColumns={
              showComparisonAndDifferenceColumns
            }
            fieldName="commitmentAmount"
          />
        )}
      />
    </Box>
  );
};
